import { handleActions } from 'redux-actions'
import { setIntegration, setIntegrationSuccess, syncIntegrationSuccess } from './integrationActions'

class State {
  loading = true
}

export const integration = handleActions<State, any>(
  {
    [String(setIntegration)]: (state: State): State => ({
      ...state,
      loading: true,
    }),
    [String(setIntegrationSuccess)]: (state: State): State => ({
      ...state,
      loading: false,
    }),
    [String(syncIntegrationSuccess)]: (state: State): State => ({
      ...state,
    }),
  },
  new State(),
)

export { State as IntegrationState }
